import { MatTableDataSource, MatPaginator, MatSort } from '@angular/material';
import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { DatePipe } from "@angular/common";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesDates, MessagesGeneral, MessagesTitles, MessagesSimuladorAgregarDetalle, MessagesStatus } from '../../../models/messages';
import { SecurityService } from '../../../services/security/security.service';
import { LoginService } from '../../../services/login/login.service';
import { Router } from '@angular/router';
import Swal from "sweetalert2";
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-detalle-guia',
  templateUrl: './detalle-guia.component.html',
  styleUrls: ['./detalle-guia.component.scss'],
  providers: [DatePipe, MessagesTitles, MessagesGeneral, MessagesDates, MessagesSimuladorAgregarDetalle, MessagesStatus]
})
export class DetalleGuiaComponent implements OnInit {
  @Output() cerrarPopUpGuiaDetalle = new EventEmitter<boolean>();
  abrirPopUpGuia: boolean = false;
  form: FormGroup;
  user: any;
  isLoading: boolean = true;
  guiaPadre: any;
  dataGuia: any;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  RepComponentes: any = [];
  loading: boolean = false;
  data: any = {};

  displayedColumns: string[] =
    ['Checked', 'Codigo', 'Descripcion', 'Sistema', 'Estado'];

  dataSource = new MatTableDataSource(this.RepComponentes);
  Titulo: string;

  constructor(private securityService: SecurityService,
    private loginService: LoginService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private router: Router) {

    this.dataGuia = this.securityService.dataGuiaDetalle;

    this.loginService.ensurePublicIpStored();
    this.user = JSON.parse(sessionStorage.getItem('UserActive'));

    this.data.NombreProyecto = 'DigitalFactoring';
    this.data.Usuario = this.user && this.user.Usuario ? this.user.Usuario : '';
    this.data.Host = 'INTRANET';
    this.data.IP = this.loginService.getPublicIpAddress();
    this.data.Canal = 'W';
  }

  ngOnInit() {
    this.ObtenerListaguias();
  }

  ObtenerListaguias() {
    this.loading = true;
    this.securityService.ObtenerListaGuias(this.dataGuia.idGuia)
      .subscribe(resp => {
        this.isLoading = false;
        this.RepComponentes = resp
        this.dataSource = new MatTableDataSource(this.RepComponentes);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        this.isLoading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA GUIAS no encontrado. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }
  AgregarGuia() {
    this.securityService.isDetalleGuia = true;
    this.securityService.dataGuia = '';
    this.abrirPopUpGuia = true;
  }


  EditarGuia(elemento: any) {
    this.securityService.dataGuia = elemento;
    this.abrirPopUpGuia = true;
  }
  EliminarGuia(element: any) {

    this.data.idGuia = element.idGuia;
    this.data.Estado = '0';

    Swal.fire({
      title: '',
      text: '¿Estás seguro de eliminar el id: ' + element.idGuia + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.securityService.ActualizarGuia(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡La guia ha sido dado de baja!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value) {
                this.ngOnInit();
              }
            });

          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE ELIMINÓ GUIA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false;
      }
    })

  }

  CerrarPopUpGuia() {
    this.cerrarPopUpGuiaDetalle.emit();
  }
  Refresh() {
    this.ngOnInit();
  }

}
